


import Fruits from "./Fruits"
import BestDeals from "./BestDeals"
import Vegetables from './Vegetables';
import CenterImages from "./CenterImages"
import {
  Box,
  Flex,
  Image,

} from "@chakra-ui/react";
import sideOne from "../../HomePageAssets/sideOne.png"
import sideTwo from "../../HomePageAssets/sideTwo.png";
import sideThree from "../../HomePageAssets/sideThree.png";
import ImageSlider from "./ImageSlider";
import DownloadApp from "../../Component/DownloadApp";
const sliderImg = [
  { img: "https://cdn.grabon.in/gograbon/images/web-images/uploads/1655372749937/fraazo-coupons.jpg", id: 3763 },
  { img: "https://askmeguy.com/wp-content/uploads/2021/12/3-KG-Onion-Potato-Tomato-Combo-Offer-Coupon-Fraazo-1024x425.jpg", id: 3765 },
  { img: "https://askmeguy.com/wp-content/uploads/2021/12/Free-Masala-Offer-Fraazo-Coupon-1024x426.jpg", id: 3766 },
  { img: "https://1.bp.blogspot.com/-RAehoUSpgDU/YCydCSZ4W9I/AAAAAAAAYMo/sWTXS-xQeisdGHg9sroK0XiPvyhBbht8QCLcBGAsYHQ/s761/F2.PNG", id: 3767 },
  { img: "https://askmeguy.com/wp-content/uploads/2021/12/Fraazo-2-KG-Onion-Offer.jpg", id: 3768 },
]

function SamHome() {
  return (
    <div style={{marginTop:'80px'}}>
      <Box mt={"80px"}>
        <Box p={"0 60px"}>
          <Flex gap={7}>
            <Box w="65%" color="white">
              <ImageSlider key={sliderImg.id} />
            </Box>
            <Box w="33%">
              <Flex flexDir={"column"} gap={4}>
                <Box>
                  <Image w={"100%"} maxH={"111px"} src={sideOne} />
                </Box>
                <Box>
                  <Image w={"100%"} maxH={"111px"} src={sideTwo} />
                </Box>
                <Box>
                  <Image w={"100%"} maxH={"111px"} src={sideThree} />
                </Box>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>

      <BestDeals />
      <CenterImages />
      <Fruits />
      <Vegetables />
      <DownloadApp />
    </div>
  );
}

export default SamHome;
